import React, { Component } from "react";

export default class Experience extends Component {
  render() {
    return (
      <>
        <h2 className="heading">Experience</h2>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">Jan 2022 - Present</span>
            <h2>Front-End Web Developer</h2>
            <span className="position">SyncTree, Seoul, South Korea</span>
            <p>
              -Spearheaded the transformation of a no-code backend API solution
              project, significantly enhancing service render time from 35 FPS
              to 55 FPS. This improvement involved restructuring the component
              architecture to support over 1000 blocks.
            </p>
            <p>
              -Designed and implemented a range of essential design components,
              including Calendar, Table, Button, Tooltip, etc., to elevate the
              front-end development environment. Leveraged the Storybook tool to
              facilitate design component development.
            </p>
            <p>
              -Upheld top-notch code quality standards through rigorous testing
              using the Jest tool.
            </p>
            <p>
              -Effectively managed client state with React, utilizing the Mobx
              library.
            </p>
            <p>
              -Led the ground-up development of the BackOffice system for
              overseeing Synctree's block store feature.
            </p>
            <p>
              -Showcased expertise in pure JavaScript and functional
              programming, collaborating on the block library (blockly) from
              Google built with vanilla JavaScript.
            </p>
          </div>
        </div>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">Apr 2021 - Nov 2021</span>
            <h2>Full-Stack Web Developer</h2>
            <span className="position">MetLife, Seoul, South Korea</span>
            <p>
              -Successfully transitioned a legacy website to a modernized
              version using cutting-edge stacks, including React with TypeScript
              and SpringBoot.
            </p>
            <p>
              -Streamlined the legacy codebase and project architecture,
              resulting in a 30% reduction in bug incidents.
            </p>
            <p>
              -Implemented Redux Toolkit and Next.js to optimize React state
              management and enable server-side rendering (SSR) for the
              application.
            </p>
            <p>
              -Played a pivotal role in cross-functional teamwork, liaising
              effectively with designers, product managers, and fellow
              developers to deliver high-quality products on schedule.
            </p>
            <p>
              -Ensured code quality through rigorous testing, code reviews, and
              adherence to best practices
            </p>
            <p>
              -Demonstrated proficiency in tech stacks like JSP, HTML, and Java
              due to the previous project's utilization of these technologies.
            </p>
          </div>
        </div>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">Apr 2020 - Mar 2021</span>
            <h2>Full-Stack Web Developer</h2>
            <span className="position">
              IHS Markit, London, Ontario, Canada
            </span>
            <p>
              -Designed sophisticated components using Material-UI and created
              models and API routes for user profiles and project management,
              employing React, Express, and MongoDB. Implemented AWS S3 for
              efficient image data storage.
            </p>
            <p>
              -Developed and integrated REST APIs, collaborating with
              third-party APIs for seamless data flow
            </p>
            <p>
              -Actively participated in agile development processes, including
              daily stand-ups, sprint planning, and retrospectives, ensuring
              project alignment with objectives.
            </p>
            <p>
              -Pioneered the implementation of real-time chat functionality
              using web sockets for enhanced user interaction
            </p>
            <p>
              -Exhibited a profound understanding of software design patterns,
              object-oriented programming, and data structures, contributing to
              project success
            </p>
          </div>
        </div>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">Oct 2019 - Present</span>
            <h2>Freelance Web Developer (Full-Stack)</h2>
            <span className="position">Ozen Restaurant, London, Ontario</span>
            <p>
              -Designing and developing user-friendly website, include
              optimizing other food platform link pages such as UberEats, Skip
              The Dishes
            </p>
            <p>
              -Extensively utilizing Github for version control in an agile
              development environment
            </p>
            <p>
              -Making the data set in 'Contentful' software layout, so that the
              website owner can update or add the data easily thorugh the
              Contentful
            </p>
            <p>-Technology Used: React.js, node.js, CSS, Github, Contentful</p>
          </div>
        </div>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">May 2016 - 2020 Feb</span>
            <h2>Restaurant Manager</h2>
            <span className="position">Ozen Restaurant, London, Ontario</span>
            <p>
              -Managing the restaurant transactions to calculate daily profit,
              tip distribution
            </p>
            <p>
              -Estimating consumption, forecasting requirements, and maintaining
              inventory
            </p>
            <p>-Training and evaluating staff performance</p>
            <p>-Responding efficiently to customer questions and complaints</p>
          </div>
        </div>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">Sep 2019 – Dec 2019</span>
            <h2>Fundamental C++ Tutor</h2>
            <span className="position">Fanshawe College, London, Ontario</span>
            <p>
              -Reviewing recent assignment and test scores, and work throughout
              the problems or questions that the student did not responded
              correctly
            </p>
            <p>-Preparing the student for upcoming tests and quizzes</p>
          </div>
        </div>
        <div className="resume-wrap d-flex ftco-animate">
          <div className="icon d-flex align-items-center justify-content-center">
            <span className="flaticon-ideas"></span>
          </div>
          <div className="text pl-3">
            <span className="date">Oct 2010 – July 2012 </span>
            <h2>Field Artillery Army Squad-Leader</h2>
            <span className="position">South Korea</span>
            <p>
              -Leading a squad of six infantry through extensive military
              training
            </p>
            <p>
              -Responsible for the well-being of squad and ensuring goals and
              duties were completed successfully
            </p>
            <p>-Training and providing mentorship to new squad members</p>
          </div>
        </div>
      </>
    );
  }
}
